import { render, staticRenderFns } from "./AllRewards.vue?vue&type=template&id=270055b4&scoped=true"
import script from "./AllRewards.vue?vue&type=script&lang=js"
export * from "./AllRewards.vue?vue&type=script&lang=js"
import style0 from "./AllRewards.vue?vue&type=style&index=0&id=270055b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270055b4",
  null
  
)

export default component.exports